import { BreakpointKey } from "@insite/mobius/utilities/breakpointMediaQueries";
import isBreakpoint from "@toolkit/Framework/Common/Utilities/isBreakpoint";
import { MediaOption } from "@toolkit/Framework/Common/Utilities/mediaQueries";
import { useWindowContext } from "@toolkit/Framework/Components/WindowContext";
import { useTheme } from "styled-components";

const useIsBreakpoint = (breakpoint: BreakpointKey | undefined, mediaOption: MediaOption = "only") => {
    const theme = useTheme();
    const { currentBreakpoint } = useWindowContext();

    return breakpoint ? isBreakpoint(theme, currentBreakpoint, breakpoint, mediaOption) : false;
};

export default useIsBreakpoint;
